import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DialogService } from '@app/old-ui/dialog/dialog.service';
import { WebClient } from '@injectables';
import { User } from '@models';
import { timezonesData, dateFormats } from '@lib/timezone-preference-list';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TargetIntervalsComponent } from '@app/new-ui/manage/target-intervals/target-intervals.component';

@Component({
    selector: 'preferences',
    templateUrl: './user-preferences.component.html',
    styleUrls: ['./user-preferences.component.scss']
})
export class UserPreferencesComponent implements OnInit {
    constructor(
        private formBuilder: FormBuilder,
        private readonly webClient: WebClient,
        public readonly user: User,
        private fragQuery: FragQueryService,
        private readonly dialog: DialogService,
        private readonly snackBar:MatSnackBar
    ) { }

    private _targetIntervalsComponent: TargetIntervalsComponent<User>;
    @ViewChild(TargetIntervalsComponent)
    set targetIntervalsComponent(component: TargetIntervalsComponent<User>) {
        this._targetIntervalsComponent = component;
        if (component) {
            component.enableSaving = true;
        }
    }
    get targetIntervalsComponent(): TargetIntervalsComponent<User> { return this._targetIntervalsComponent; }

    public breakpoint: number;
    public formGroup: FormGroup;
    public visibleDeviceDropDown =  false
    public readonly devices$ = this.fragQuery.devices$;
    public readonly device$ = this.fragQuery.device$;
    public readonly timezonesData = timezonesData;
    public readonly dateFormats = dateFormats;
    public readonly restClient = this.webClient.model.user;
    public readonly particleSizeUnitSystem$ = this.fragQuery.particleSizeUnitSystem$;

    public ngAfterViewInit() {
        if (this.targetIntervalsComponent) {
            this.targetIntervalsComponent.enableSaving = true;
        }
    }

    ngOnInit(): void {
    
        this.formGroup = this.formBuilder.group({
            cameraSpeed: [this.user.cameraSpeed],
            sieveSize: [this.user.sieveSize],
            particleSizeDistributionModel: [this.user.particleSizeDistributionModel],
            timezone: this.user.timezone,
            particleSizeUnit: this.user.particleUnit,
            quantityUnit: this.user.quantityUnit,
            dateFormat: [this.user.dateFormat],
            timeFormat: [this.user.timeFormat],
            minTargetSize: [this.user.minTargetSize],
            maxTargetSize: [this.user.maxTargetSize],
            targetIntervals: [this.user.targetIntervals],
            dailySummary: this.user.dailySummaryMail,
            preferCustomSizes:[this.user.preferCustomSizes],
            intervals: [''],
        });
        this.breakpoint = window.innerWidth <= 600 ? 1 : 2;
    }

    timezoneOffsetAvailable(): boolean {
        if (this.formGroup.get('timezone').value && timezonesData.tz2.find(timezone => timezone.value === this.formGroup.get('timezone').value)?.offset) {
            return true;
        } else {
            return false;
        }
    }

    public saveUserTargetSizes = async (user: User) => {
        return this.webClient.model.user.save(user);
    }

    async saveSettings() {
        this.user.cameraSpeed = this.formGroup.get('cameraSpeed').value;
        this.user.sieveSize = this.formGroup.get('sieveSize').value;
        this.user.particleSizeDistributionModel = this.formGroup.get('particleSizeDistributionModel').value;
        this.user.timezone = this.formGroup.get('timezone').value;
        this.user.dateFormat = this.formGroup.get('dateFormat').value;
        this.user.timeFormat = this.formGroup.get('timeFormat').value;
        this.user.particleUnit = this.formGroup.get('particleSizeUnit').value;
        this.user.quantityUnit = this.formGroup.get('quantityUnit').value;
        this.user.dailySummaryMail = this.formGroup.get('dailySummary').value;
        this.user.minTargetSize = this.formGroup.get('minTargetSize').value;
        this.user.maxTargetSize = this.formGroup.get('maxTargetSize').value;
        this.user.targetIntervals = this.formGroup.get('targetIntervals').value;
        this.user.preferCustomSizes= this.formGroup.get('preferCustomSizes').value;
        if (this.targetIntervalsComponent) {
            this.targetIntervalsComponent.saveSettings();
        }
        if (this.timezoneOffsetAvailable()) {
            this.user.timezoneOffset = timezonesData.tz2.find(timezone => timezone.value === this.formGroup.get('timezone').value).offset * 60;
        } else {
            this.user.timezoneOffset = (new Date().getTimezoneOffset() * -1);
        }

        try {
            await this.dialog.await(this.restClient.save(this.user));
            this.snackBar.open('Settings saved successfully', 'OK', {
                duration: 5000,
                panelClass: ['snackbar-success']
            });
            this.fragQuery.trigger$.next();
        } catch (error) {
            console.error('Error saving settings:', error);
        }
    }
}
